import type { Product } from "../types";

export const resolveStep = (product: Product | null | undefined) => {
  const value = Number(product?.coefficient);
  return Number.isFinite(value) && value > 0 ? value : 1;
};

export const resolveMinQuantitySimple = (
  product: Product | null | undefined,
  baseMinQuantity = 0,
) => {
  const step = resolveStep(product);
  const normalizedBase =
    Number.isFinite(Number(baseMinQuantity)) && Number(baseMinQuantity) > 0
      ? Number(baseMinQuantity)
      : 0;
  return Math.max(normalizedBase, step);
};

export const resolveMinQuantityRounded = (
  product: Product | null | undefined,
  baseMinQuantity = 0,
) => {
  const step = resolveStep(product);
  const normalizedBase =
    Number.isFinite(Number(baseMinQuantity)) && Number(baseMinQuantity) > 0
      ? Number(baseMinQuantity)
      : step;

  if (!Number.isFinite(step) || step <= 0) {
    return normalizedBase || 0;
  }

  const rounded = Math.ceil((normalizedBase || step) / step) * step;
  return Math.max(step, rounded);
};

export const formatProductName = (product: Product | null | undefined) => {
  if (!product) {
    return "";
  }
  const step = resolveStep(product);
  const baseName = product.name || `Produkt #${product.id ?? ""}`.trim();
  if (step <= 1) {
    return baseName;
  }
  const label = Number.isInteger(step)
    ? step.toString()
    : step.toFixed(2).replace(/\.?0+$/, "");
  return `${baseName} (${label})`;
};
